module.exports = __webpack_public_path__ + "img/luojigouLogo.1e3e86f6.png";